import IService from "@api/iService";
import { ICheckGift, IGift } from "@interfaces/user/daily";

export default class DailyService extends IService {

    async getGifts() {
        return await this.getApi<IGift[]>('/api/user/daily/');
    }

    async checkDaily () {
        return await this.getApi<ICheckGift>('/api/user/daily/check/');
    }
    
}